import { createSlice } from "@reduxjs/toolkit";
import storageService from "../../utils/storage";

const initialState = {
  user: null,
};

export const userSlice = createSlice({
  initialState,
  name: "userSlice",
  reducers: {
    logout: (state, action) => {
      if (action?.payload === null) {
        storageService.clear();
      }
      state.user = null;
    },
    setUser: (state, action) => {
      // the login response still carries a token for other API clients; the dashboard uses the cookie
      const { token, ...user } = action?.payload?.data || {};
      state.user = action?.payload?.data ? user : action?.payload?.data;
    },
  },
});

export default userSlice.reducer;

export const { logout, setUser } = userSlice.actions;
